// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2lJ7x","description":"PatientConsentPreview_description__3aZYq"};